import { CategoryNodeResponse } from './category.response';
import { CategoryNodeState } from './category.state';

/** Pure wire → state mapper for the taxonomy endpoints; children map recursively. */

export function mapCategoryNodeResponse(response: CategoryNodeResponse): CategoryNodeState {
  return {
    ...response,
    children: response.children.map(mapCategoryNodeResponse)
  };
}
